import "./Local_Benefits.css";

const Local_Benefits = () => {
  return (
    <section className="local-benefits">
      <div className="container">
        <h4 className="local-benefits-title">
         Why People Preferred Loconex
        </h4>

        <div className="local-benefits-grid">
          <div className="whatwedo-card">
            <span className="whatwedo-icon">📍</span>
            <p>Nearby Local Shops</p>
          </div>

          <div className="whatwedo-card">
            <span className="whatwedo-icon">💬</span>
            <p>Direct WhatsApp Chat with Seller</p>
          </div>

          <div className="whatwedo-card">
            <span className="whatwedo-icon">💸</span>
            <p>Exclusive Local Discounts</p>
          </div>

          <div className="whatwedo-card">
            <span className="whatwedo-icon">📦</span>
            <p>Book or Order Easily</p>
          </div>

          <div className="whatwedo-card">
            <span className="whatwedo-icon">🤝</span>
            <p>Supporting Small Businesses</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Local_Benefits;
